import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

import { BrowserRouter, HashRouter } from "react-router-dom";

import "@fortawesome/fontawesome-free/css/all.min.css";
//+Redux
import { Provider } from "react-redux";
import store from "./Redux/store";
//-Redux

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
  <BrowserRouter basename="/">
    {/* Redux portal */}
    <Provider store={store}>
      <App />
    </Provider>
  </BrowserRouter>
  // </React.StrictMode> 
);
